import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SelectModule } from '@cmps/ng-select';
import {
    CmpsButtonModule,
    CmpsIconModule,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';
import { TranslateModule } from '@ngx-translate/core';

import { CmpsCommonModule } from '../../../../common/common.module';
import { CmpsLazyI18nModule } from '../../../../i18n/i18n.module';
import { ExperimentalNgGridModule } from '../grid';

import { MainComponent } from './main.component';
import { TranslationIdMap } from './main.i18n';

@NgModule({
    declarations: [MainComponent],
    exports: [MainComponent],
    imports: [
        CmpsButtonModule,
        CmpsCommonModule,
        CmpsIconModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsTooltipModule,
        CommonModule,
        ExperimentalNgGridModule,
        FormsModule,
        SelectModule,
        TranslateModule,
        ExperimentalNgGridModule,
        ExperimentalNgGridModule,
        ExperimentalNgGridModule,
    ],
})
export class CmpsCoachingWpMainModule {}
